export const SHOW_IN_TAB_OPTIONS = [
  { label: 'Hiện', value: 1 },
  { label: 'Ẩn', value: 0 },
];

export const SHOW_IN_TAB_ID = {
  SHOW: 1,
  HIDE: 0,
};
